<template>
  <div class="zhanwei4"></div>

  <div class="top_review_input">
    <el-input
      v-model="globalReviewLink"
      placeholder="全局复盘视频链接"
      size="large"
    />
    <el-button
      type="primary"
      size="large"
      style="width: 400px"
      @click="saveReviewLink()"
      >保存</el-button
    >
  </div>

  <div class="select-bar-wrapper">
    <el-segmented
      v-model="levelValue"
      :options="levelsOptions"
      block
      @change="changeOption"
      size="large"
      class="selectBar"
    />
  </div>

  <div class="form-container">
    <div class="panel">
      <div class="panel_left">
        <el-form
          :model="form"
          label-width="auto"
          label-position="top"
          ref="ruleForm"
          status-icon
          class="clean-form"
        >
          <el-form-item label="复盘标题">
            <el-input
              v-model="form.reviewTitle"
              placeholder="请输入复盘标题..."
              size="large"
            />
          </el-form-item>

          <el-form-item label="复盘内容">
            <el-input
              v-model="form.reviewContent"
              type="textarea"
              placeholder="请输入复盘的核心内容..."
              size="large"
              rows="8"
              maxlength="500"
              show-word-limit
            />
          </el-form-item>

          <el-form-item label="展示媒体类型">
            <el-radio-group v-model="mediaType" size="large">
              <el-radio-group-button>
                <el-radio-button label="image">图片</el-radio-button>
                <!--                <el-radio-button label="video">视频链接</el-radio-button>-->
              </el-radio-group-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="复盘图片" v-if="mediaType === 'image'">
            <div class="upload-wrapper">
              <el-upload
                class="avatar-uploader"
                :action="UpdateApi"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList"
                :disabled="allowUpload"
              >
                <el-image
                  :src="form.reviewImg"
                  v-if="form.reviewImg"
                  class="avatar"
                  alt="复盘图片"
                  fit="cover"
                >
                  <template #error>
                    <div class="image-slot">
                      <el-icon><icon-picture /></el-icon>
                    </div>
                  </template>
                </el-image>
                <div v-else class="uploader-placeholder">
                  <el-icon class="avatar-uploader-icon"><Plus /></el-icon>
                  <span class="upload-text">选择上传图片</span>
                </div>
              </el-upload>
              <el-button
                v-if="allowUpload"
                type="warning"
                plain
                class="clear-img-btn"
                @click="clearImage"
              >
                {{ $t("settings.clearImg") }}
              </el-button>
            </div>
          </el-form-item>

          <el-form-item label="视频链接" v-if="mediaType === 'video'">
            <el-input
              v-model="form.reviewLink"
              placeholder="请输入视频的嵌入式 URL (例如: https://www.youtube.com/embed/...)"
              type="url"
              size="large"
              clearable
            />
            <div
              style="
                font-size: 12px;
                color: #909399;
                margin-top: 6px;
                line-height: 1.4;
              "
            >
              *
              提示：为了能在网页上正常播放，请确保使用的是支持嵌入的链接格式（如带有
              /embed/ 的链接）。
            </div>
          </el-form-item>
        </el-form>

        <div class="action-bar">
          <el-button
            type="primary"
            class="save-btn"
            size="large"
            @click="saveSettings"
          >
            保存当前关卡
          </el-button>
        </div>
      </div>

      <div class="panel_right">
        <p class="preview-title">App 实时预览</p>
        <div class="phone-mockup">
          <div class="phone-screen">
            <div class="phone-media">
              <img
                v-if="mediaType === 'image' && form.reviewImg"
                :src="form.reviewImg"
                alt="图片预览"
                class="preview-img"
              />

              <div v-else-if="mediaType === 'video'" class="video-container">
                <iframe
                  v-if="form.reviewLink"
                  :src="form.reviewLink"
                  scrolling="no"
                  border="0"
                  frameborder="no"
                  framespacing="0"
                  allowfullscreen="true"
                  class="preview-iframe"
                ></iframe>
                <div v-else class="media-placeholder">
                  <el-icon style="font-size: 32px"><VideoPlay /></el-icon>
                  <span style="margin-top: 8px; font-size: 12px"
                    >暂无视频链接</span
                  >
                </div>
              </div>

              <div v-else class="media-placeholder">
                <el-icon style="font-size: 32px"><Picture /></el-icon>
                <span style="margin-top: 8px; font-size: 12px"
                  >暂无图片展示</span
                >
              </div>
            </div>

            <div class="phone-content">
              <h3 class="app-content-title">
                {{ form.reviewTitle || "暂无标题" }}
              </h3>
              <p class="app-content-desc">
                {{ form.reviewContent || "暂无内容描述..." }}
              </p>
            </div>

            <div class="phone-bottom-action">
              <div class="continue-button">继续</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="zhanwei4"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Plus, Picture, VideoPlay } from "@element-plus/icons-vue";
import { ElMessage, ElNotification } from "element-plus";

export default defineComponent({
  name: "App",
  components: { Plus, Picture, VideoPlay },
  props: ["dataForm"],
  data(): any {
    return {
      globalReviewLink: "",
      form: {
        reviewTitle: "",
        reviewImg: "",
        reviewLink: "",
        reviewContent: "",
      },
      mediaType: "image", // 用于控制前端是图片还是视频的展示状态 ('image' 或 'video')
      fileList: [],
      levelValue: "",
      game: null,
    };
  },
  computed: {
    story(): number {
      return this.$store.state.game.story;
    },
    allowUpload() {
      return this.form.reviewImg !== "" && this.form.reviewImg !== null;
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
    levelsOptions() {
      return this.$store.state.game.levels.map((item) => item.name);
    },
  },
  watch: {
    levelsOptions: {
      immediate: true,
      handler(newOptions) {
        if (newOptions && newOptions.length > 0) {
          if (!this.levelValue) {
            this.levelValue = newOptions[0];
            this.changeOption(this.levelValue);
          }
        }
      },
    },
    dataForm: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.updateForm(newVal);
        }
      },
    },
  },
  mounted() {
    if (this.$route.params.id != 0) {
      const game = this.$store.state.game.games.find((item: any) => {
        return item.id == this.$route.params.id;
      });
      this.game = game;
      this.globalReviewLink = game.globalReviewLink;
    }
  },
  methods: {
    updateForm(dataForm) {
      this.form.reviewTitle = dataForm.reviewTitle;
      this.form.reviewImg = dataForm.reviewImg;
      this.form.reviewContent = dataForm.reviewContent;
    },
    // 根据后端返回的数据，智能检测并回显当前媒体分类
    initMediaShowType() {
      // 视频链接存在，且带有常见可嵌入字符时，默认切换到视频页
      // if (
      //   this.form.reviewLink &&
      //   (this.form.reviewLink.includes("embed") ||
      //     this.form.reviewLink.includes("player"))
      // ) {
      //   this.mediaType = "video";
      // } else {
      //   this.mediaType = "image";
      // }
      this.mediaType = "image";
    },
    beforeAvatarUpload(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传 png 或 jpg 格式图片",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于 2MB",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      return true;
    },
    handleAvatarSuccess(response: any) {
      this.form.reviewImg = response.data.returnFileUrl;
    },
    clearImage() {
      this.form.reviewImg = "";
      this.fileList = [];
    },
    // 保存按钮
    saveSettings() {
      const level = this.$store.state.game.levels.find(
        (item) => item.name == this.levelValue
      );

      if (!level) {
        ElMessage.error("未找到当前关卡信息");
        return;
      }

      // 如果选的是视频，就把图片 reviewImg 置空再提交；如果选的是图片，就把 reviewLink 链接置空提交（确保数据库字段干净）
      const reviewImg =
        this.mediaType === "image" ? this.form.reviewImg || "" : null;
      const reviewLink =
        this.mediaType === "video" ? this.form.reviewLink || "" : null;

      this.$store
        .dispatch("game/editGameReview", {
          gameLevelId: level.levelId,
          reviewTitle: this.form.reviewTitle || "",
          reviewContent: this.form.reviewContent || "",
          reviewLink: reviewLink,
          reviewImg: reviewImg,
        })
        .then((res: any) => {
          ElMessage.success({ message: `${this.levelValue} 复盘修改成功` });
        })
        .catch((err) => {
          console.error(err);
          ElMessage.error({ message: "修改失败，请重试" });
        });
    },
    // 切换关卡
    changeOption(val) {
      const level = this.$store.state.game.levels.find(
        (item) => item.name == val
      );
      if (!level) return;

      this.$store
        .dispatch("game/getLevelDetail", { levelId: level.levelId })
        .then((res: any) => {
          if (res && res.levelInfo) {
            console.log(res);
            this.form = {
              reviewTitle: res.levelInfo.reviewTitle || "",
              reviewImg: res.levelInfo.reviewImg || "",
              reviewLink: res.levelInfo.reviewLink || "",
              reviewContent: res.levelInfo.reviewContent || "",
            };
            this.initMediaShowType(); // 自动识别回显类型
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    saveReviewLink() {
      this.game.globalReviewLink = this.globalReviewLink;

      const { updateTime, ...formWithoutUpdateTime } = this.game;
      // 避免修改原始对象
      const payload = { ...formWithoutUpdateTime };
      payload.tips = JSON.stringify(payload.tips);
      payload.region = this.game.region.join(",");
      this.$store
        .dispatch("game/updateGame", { gameBean: payload })
        .then(() => {})
        .catch(() => {
          this.$message.error("保存失败");
        });
    },
  },
});
</script>

<style lang="less" scoped>
/* 关卡切换条外裹区 */
.select-bar-wrapper {
  max-width: 1200px;
  margin: 0 auto 24px;
  padding: 0 20px;
}

/* 主面板容器布局 */
.form-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.top_review_input {
  width: 100%;
  height: 200px;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
}

.panel {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
  background: #ffffff;
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;

  /* 左侧表单部分 */
  &_left {
    flex: 1;
    max-width: 600px;

    .clean-form {
      :deep(.el-form-item) {
        margin-bottom: 24px;

        .el-form-item__label {
          font-weight: 600;
          color: #2c3e50;
          padding-bottom: 8px;
        }
      }
    }

    /* 上传组件精美美化 */
    .upload-wrapper {
      display: flex;
      align-items: flex-end;
      gap: 16px;
    }

    .avatar-uploader {
      border: 1px dashed #dcdfe6;
      border-radius: 8px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 160px;
      height: 160px;
      transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
      background: #fafafa;

      &:hover {
        border-color: #409eff;
        background: #f5f7fa;
      }

      .avatar {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .uploader-placeholder {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        color: #909399;

        .avatar-uploader-icon {
          font-size: 24px;
          margin-bottom: 8px;
        }

        .upload-text {
          font-size: 12px;
        }
      }
    }

    .clear-img-btn {
      height: 36px;
    }

    .action-bar {
      margin-top: 32px;
      border-top: 1px solid #f2f2f2;
      padding-top: 24px;

      .save-btn {
        width: 100%;
        background-color: #2c3e50;
        border-color: #2c3e50;
        font-weight: bold;
        transition: all 0.2s ease;

        &:hover {
          background-color: #1a252f;
          border-color: #1a252f;
        }
      }
    }
  }

  /* 右侧精美 App 模拟预览区 */
  &_right {
    width: 380px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    flex-shrink: 0;

    .preview-title {
      margin-bottom: 24px;
      font-size: 16px;
      font-weight: 600;
      color: #57606f;
    }

    /* 模拟手机容器 */
    .phone-mockup {
      width: 300px;
      height: 600px;
      background: #000000;
      border-radius: 36px;
      padding: 12px;
      box-shadow: 0 12px 36px rgba(0, 0, 0, 0.15);
      box-sizing: border-box;

      .phone-screen {
        width: 100%;
        height: 100%;
        background: #ffffff;
        border-radius: 26px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        position: relative;

        /* 手机内嵌媒体展示区 (统一高度并加入 iframe 播放器支持) */
        .phone-media {
          width: 100%;
          height: 45%;
          background: #f5f7fa;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;

          .preview-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          /* 视频容器与 Iframe 规范 */
          .video-container {
            width: 100%;
            height: 100%;
            position: relative;

            .preview-iframe {
              width: 100%;
              height: 100%;
              border: none;
            }
          }

          .media-placeholder {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #b2bec3;
          }
        }

        /* 手机内容排版区 */
        .phone-content {
          flex: 1;
          padding: 16px;
          overflow-y: auto;
          box-sizing: border-box;

          .app-content-title {
            margin: 0 0 12px 0;
            font-size: 16px;
            font-weight: bold;
            color: #2d3436;
            text-align: center;
            line-height: 1.4;
          }

          .app-content-desc {
            margin: 0;
            font-size: 13px;
            color: #636e72;
            line-height: 1.6;
            white-space: pre-wrap;
            font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
          }
        }

        /* 手机底部固定的继续按钮 */
        .phone-bottom-action {
          padding: 12px 16px 20px;
          background: #ffffff;
          box-sizing: border-box;

          .continue-button {
            width: 100%;
            height: 40px;
            background: #02a7e5;
            color: #ffffff;
            font-weight: 600;
            border-radius: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            box-shadow: 0 4px 10px rgba(2, 167, 229, 0.3);
            cursor: pointer;
            transition: background 0.2s;

            &:hover {
              background: #0093cc;
            }
          }
        }
      }
    }
  }
}

/* 响应式适配 */
@media screen and (max-width: 1200px) {
  .panel {
    padding: 24px;
    flex-direction: column;
    align-items: center;

    &_left {
      width: 100%;
      max-width: 100%;
    }

    &_right {
      display: none;
    }
  }
}
</style>
